import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { ReactiveFormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { MessageService } from 'primeng/api';
import { CookieService } from 'ngx-cookie-service';

import { AppComponent } from './app.component';
import { LeadResellerVfComponent } from './pages/lead-reseller-vf/lead-reseller-vf.component';
import { PanelAdminComponent } from './pages/panel-admin/panel-admin.component';
import { FormularioComponent } from './component/formulario/formulario.component';
import { PickComponent } from './component/formulario/components/pick/pick.component';
import { RadioButtonModule } from 'primeng/radiobutton';
import { CheckboxModule } from 'primeng/checkbox';
import { ToastModule } from 'primeng/toast';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule } from '@angular/common/http';
import { DialogModule } from 'primeng/dialog';
import { TablaComponent } from './component/tabla/tabla.component';
import { TableModule } from 'primeng/table'
import { FormsModule } from '@angular/forms';
import { LoginComponent } from './pages/login/login.component';
import { DividerModule } from 'primeng/divider';
import { InputTextModule } from 'primeng/inputtext';
import { ResgistroAdminComponent } from './pages/resgistro-admin/resgistro-admin.component';
import { RestaurarPasswordComponent } from './pages/restaurar-password/restaurar-password.component';
import { PasswordModule } from 'primeng/password';
import { LogoutComponent } from './component/logout/logout.component';
import { TooltipModule } from 'primeng/tooltip';
import { DropdownModule } from 'primeng/dropdown';
import { MenubarModule } from 'primeng/menubar';
import { MenubarComponent } from './component/menubar/menubar.component';
import { GestionComponent } from './pages/gestion/gestion.component';
import { SplitButtonModule } from 'primeng/splitbutton';

@NgModule({
  declarations: [
    AppComponent,
    LeadResellerVfComponent,
    PanelAdminComponent,
    FormularioComponent,
    PickComponent,
    TablaComponent,
    LoginComponent,
    ResgistroAdminComponent,
    RestaurarPasswordComponent,
    LogoutComponent,
    MenubarComponent,
    GestionComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    ReactiveFormsModule,
    ButtonModule,
    RadioButtonModule,
    CheckboxModule,
    ToastModule,
    BrowserAnimationsModule,
    HttpClientModule,
    DialogModule,
    TableModule,
    FormsModule,
    DividerModule,
    InputTextModule,
    PasswordModule,
    TooltipModule,
    DropdownModule,
    MenubarModule,
    SplitButtonModule
  ],
  providers: [MessageService, CookieService],
  bootstrap: [AppComponent]
})
export class AppModule { }
